type PlainObject = Record<string, unknown>;

const isObject = (value: unknown): value is Record<string, unknown> =>
	value !== null && typeof value === 'object' && !Array.isArray(value);

const deepEqual = (a: unknown, b: unknown): boolean => {
	if (a === b) return true;

	if (Array.isArray(a) && Array.isArray(b)) {
		if (a.length !== b.length) return false;
		return a.every((item, index) => deepEqual(item, b[index]));
	}

	if (isObject(a) && isObject(b)) {
		const keysA = Object.keys(a);
		const keysB = Object.keys(b);
		if (keysA.length !== keysB.length) return false;
		return keysA.every(
			(key) => keysB.includes(key) && deepEqual(a[key], b[key]),
		);
	}

	return false;
};

export const diffChangedFields = (base: PlainObject, newObj: PlainObject) => {
	const result: PlainObject = {};
	const keys = new Set<string>([...Object.keys(newObj || {})]);

	Array.from(keys).forEach((key) => {
		const prev = base?.[key];
		const next = newObj?.[key];

		if (isObject(prev) && isObject(next)) {
			const nested = diffChangedFields(prev, next);
			if (Object.keys(nested).length > 0) {
				result[key] = nested;
			}
			return;
		}

		if (Array.isArray(prev) && Array.isArray(next)) {
			if (!deepEqual(prev, next)) {
				result[key] = next;
			}
			return;
		}

		if (!deepEqual(prev, next)) {
			result[key] = next;
		}
	});
	return result;
};
